//TODO: split up into common controls and advanced controls?

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { DirectiveModule } from '@Shared/Directives/proprietary/directive.module';
import { DateFormulaInputComponent } from './date-formula-input.component';
import { DateInputComponent } from './date-input.component';
import { DateOrDateFormulaInputComponent } from './date-or-date-formula.component';
import { InputComponent } from './input.component';
import { PhoneInputComponent } from './phone-input.component';
import { TimeInputComponent } from './time-input.component';
import { ZipcodeInputComponent } from './zip-input.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DirectiveModule,
        NgbDatepickerModule,
        NgbTimepickerModule,
        NgxMaskDirective,
        NgxMaskPipe
    ],
    declarations: [
        DateInputComponent,
        PhoneInputComponent,
        ZipcodeInputComponent,
        InputComponent,
        DateFormulaInputComponent,
        DateOrDateFormulaInputComponent,
        TimeInputComponent
    ],
    exports: [
        DateInputComponent,
        PhoneInputComponent,
        ZipcodeInputComponent,
        InputComponent,
        DateFormulaInputComponent,
        DateOrDateFormulaInputComponent,
        TimeInputComponent
    ],
    providers: [provideNgxMask()]
})
export class InputControlModule { }
